module.exports = __webpack_public_path__ + "static/img/2.eee6575.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/zh/2.png
// module id = 0OdR
// module chunks = 0